export const CRM_TEMPLATE_CATEGORIES = [
  "marketing",
  "utility",
  "authentication",
];

export const CRM_TEMPLATE_TYPES = [
  "text",
  "media",
];

export const CRM_HEADER_TYPES = [
  "none",
  "image",
  "video",
  "document",
];

export const CRM_BUTTON_TYPES = [
  "none",
  "dynamic_url",
  "copy_code",
  "lto_copy_code",
];

export const CRM_APPROVED_DEFAULT_TEMPLATES = [
  {
    id: "approved_apnaartist_playstore_invite_v1_36823",
    templateName: "apnaartist_playstore_invite_v1",
    wid: "36823",
    category: "marketing",
    type: "media",
    language: "English",
    bodyVariableCount: 1,
    headerRequired: true,
    headerType: "image",
    hasButton: true,
    buttonType: "static_url",
    notes: "Approved on 2026-06-09. Static Play Store CTA.",
    source: "approved_default",
    headerData: "https://admin.apnaartist.in/logo512.png",
    headerFileName: "apnaartist_playstore",
  },
];

export function parseDelimitedNumbers(input = "") {
  return Array.from(
    new Set(
      String(input || "")
        .split(/[\n,]+/g)
        .map((entry) => entry.trim())
        .filter(Boolean)
    )
  );
}

export function normalizeIndianPhone(value, fallbackCountryCode = "91") {
  const digits = String(value || "").replace(/\D/g, "");
  const countryCode = String(fallbackCountryCode || "91").replace(/\D/g, "") || "91";

  if (!digits) {
    return {
      valid: false,
      phoneRaw: String(value || ""),
      error: "Phone number is required.",
    };
  }

  let national = digits;
  let cc = countryCode;

  if (digits.length === 10) {
    national = digits;
  } else if (digits.length === 11 && digits.startsWith("0")) {
    national = digits.slice(1);
  } else if (digits.length === 12 && digits.startsWith("91")) {
    cc = "91";
    national = digits.slice(2);
  } else if (digits.length > countryCode.length && digits.startsWith(countryCode)) {
    national = digits.slice(countryCode.length);
  }

  if (!/^\d{10}$/.test(national)) {
    return {
      valid: false,
      phoneRaw: String(value || ""),
      error: "Phone must be a valid 10-digit Indian mobile number.",
    };
  }

  return {
    valid: true,
    phoneRaw: String(value || "").trim(),
    countryCode: cc,
    phoneNational: national,
    phoneE164: `+${cc}${national}`,
  };
}

export function toCrmContactPayload(raw = {}, options = {}) {
  const normalized = normalizeIndianPhone(
    raw.phone ?? raw.mobile ?? raw.phoneRaw ?? "",
    options.defaultCountryCode || "91"
  );

  const fullName = cleanText(raw.fullName || raw.full_name || raw.name || "");
  const name = cleanText(raw.name || fullName || "");
  const email = cleanText(raw.email || "");
  const city = cleanText(raw.city || "");
  const groupName = cleanText(raw.groupName || raw.group || options.groupName || "");

  if (!fullName && !name) {
    return {
      ok: false,
      error: "Name is required.",
    };
  }

  if (!normalized.valid) {
    return {
      ok: false,
      error: normalized.error,
    };
  }

  return {
    ok: true,
    payload: {
      fullName: fullName || name,
      name: name || fullName,
      phoneRaw: normalized.phoneRaw,
      phoneE164: normalized.phoneE164,
      phoneNational: normalized.phoneNational,
      countryCode: normalized.countryCode,
      email,
      city,
      groupName,
      source: options.source || "manual",
    },
  };
}

export function normalizeImportedContacts(rows = [], options = {}) {
  const accepted = [];
  const rejected = [];

  rows.forEach((row, index) => {
    const mapped = mapImportRow(row);
    const built = toCrmContactPayload(mapped, options);
    if (!built.ok) {
      rejected.push({
        index: index + 2,
        row: mapped,
        error: built.error,
      });
      return;
    }
    accepted.push({
      ...built.payload,
      previewKey: `${built.payload.phoneE164}-${index}`,
    });
  });

  return { accepted, rejected };
}

export function buildSampleContactRows() {
  return [
    {
      fullName: "Aarav Sharma",
      name: "Aarav",
      phone: "7002618625",
      email: "aarav@example.com",
      city: "Mumbai",
      groupName: "Warm Leads",
    },
    {
      fullName: "Priya Das",
      name: "Priya",
      phone: "+917123456789",
      email: "priya@example.com",
      city: "Bengaluru",
      groupName: "Event Followup",
    },
  ];
}

export function buildBodyVariableDefaults(count = 0) {
  return Array.from({ length: Math.max(0, Number(count || 0)) }, (_, index) => ({
    key: String(index + 1),
    value: "",
  }));
}

export function mapVariablePairsToObject(pairs = []) {
  return pairs.reduce((acc, pair) => {
    const key = cleanText(pair?.key || "");
    if (!key) return acc;
    acc[key] = cleanText(pair?.value || "", 500);
    return acc;
  }, {});
}

export function cleanText(value, max = 200) {
  return String(value == null ? "" : value).trim().slice(0, max);
}

function mapImportRow(row = {}) {
  const source = {};
  Object.entries(row || {}).forEach(([key, value]) => {
    source[String(key || "").trim().toLowerCase()] = value;
  });
  return {
    fullName: source.fullname || source["full name"] || row.fullName || row.full_name || "",
    name: source.name || row.name || "",
    phone: source.phone || source.mobile || source["phone number"] || row.phone || row.mobile || "",
    email: source.email || row.email || "",
    city: source.city || row.city || "",
    groupName: source.groupname || source.group || source["group name"] || row.groupName || "",
  };
}
